<template>
  <div>
    <div class="head-topbar lite-page-top linebottom sticky">
      <div class="topbar-left" @click="$router.back(-1)"><i class="icon-arrow-left"></i></div>
      <div class="topbar-main"><h4>投诉</h4></div>
    </div>
    <div class="appeal_box pb30">
      <div class="appeal-wrap">
        <div class="appeal-item pb13 linebottom">
          <div class="txt-top"><span>投诉纪念馆</span><span class="txt2">【严东生】</span></div>
        </div>
        <div class="appeal-item pt13 pb13">
          <div class="txt-top"><span>请选择投诉类型</span></div>
          <div class="txt-small">让我们共同创造一个和谐、肃穆的网上纪念平台</div>
          <div class="type-wrap">
            <div class="type-main">
              <div class="type-item"><span class="current">不实信息</span></div>
              <div class="type-item"><span class="">人身攻击</span></div>
              <div class="type-item"><span class="">有害信息</span></div>
              <div class="type-item"><span class="">违法信息</span></div>
              <div class="type-item"><span class="">宣扬仇恨</span></div>
              <div class="type-item"><span class="">其他</span></div>
            </div>
          </div>
        </div>
        <div class="appeal-item">
          <div class="edittxt" style="margin-top: 0px;">
            <textarea class="content" placeholder="请输入投诉内容（选填）"></textarea>
          </div>
        </div>
        <div class="appeal-item pt13 pb13">
          <div class="edittxt" style="margin-top: 0px;">
            <input type="text" class="inp-content" placeholder="请输入联系方式（选填）" />
          </div>
        </div>
        <div class="appeal-item">
          <div class="txt-top">上传图片凭证（选填）</div>
          <div class="edittxt">
            <div>
              <div class="weui-uploader">
                <div class="weui-uploader__bd m-auto-list" style="position: relative;">
                  <div class="m-auto-item publish-photo-item" id="plupload" style="z-index: 1;">
                    <div class="add-item flex flex_center">
                      <div class="add-item-upload add-item-upload2"></div>
                      <div class="add-item-txt"></div>
                    </div>
                  </div>
                  <div
                    id="html5_1frhcfa7fukp14vsfm31h9b1d6q4_container"
                    class="moxie-shim moxie-shim-html5"
                    style="position: absolute; top: 0px; left: 0px; width: 128px; height: 130px; overflow: hidden; z-index: 0;"
                  >
                    <input
                      id="html5_1frhcfa7fukp14vsfm31h9b1d6q4"
                      type="file"
                      style="font-size: 999px; opacity: 0; position: absolute; top: 0px; left: 0px; width: 100%; height: 100%;"
                      multiple=""
                      accept=".jpg,.jpeg,.jpg,.jpeg,.png,.png,.gif,.gif"
                      tabindex="-1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="appeal-btn"><div class="btn-sub">提交</div></div>
    </div>
    <div class="style_module_box" style="z-index: 2001; visibility: hidden;">
      <div class="style_module_mask"></div>
      <div class="style_module_dialog-box">
        <div class="style-module_dialog-main" style="border-radius: 20px;">
          <div class="style_module_dialog-close"></div>
          <div class="style_module_dialog-txt1">登录</div>
          <div class="style_module_dialog-txt2">请先登录再进行操作</div>
          <div class="style_module_dialog-content">
            <div class="input-group linebottom">
              <div class="inp-content">
                <input
                  id="apply_mobile"
                  type="number"
                  class="inp-content-input"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div class="input-group linebottom">
              <input type="text" placeholder="请输入验证码" class="form-control input-code" />
              <div class="input-group-btn">
                <span
                  class="btn btn-info btn-captcha"
                  style="color: rgb(228, 128, 60); border: 1px solid rgb(228, 128, 60); border-radius: 20px;"
                  >获取验证码</span
                >
              </div>
            </div>
            <div class="submit-btn" style="background: rgb(228, 128, 60);">登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tousu',
  data() {
    return {}
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
  },
  created() {},
  watch: {},
}
</script>

<style>
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}
.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../assets/jnt/zjt1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}

.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

element.style {
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.linebottom:after {
  content: '\20';
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #eeeff3;
  -webkit-transform: scaleY(0.5) translate(0, 1px);
  -webkit-transform-origin: 0 0;
  transform: scaleY(0.5) translate(0, 1px);
  transform-origin: 0 0;
}
element.style {
}
.appeal_box.pb30 {
  padding-bottom: 3rem;
}
.appeal_box {
  margin-top: 1rem;
}
.appeal-wrap {
  background: #fff;
  padding: 1.2rem;
  padding-top: 1.363rem;
  padding-bottom: 2rem;
}
.appeal-wrap .appeal-item.pb13 {
  padding-bottom: 1.363rem;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.appeal-wrap .txt-top {
  color: #333;
  font-size: 1.35rem;
  line-height: 1.863rem;
}
.appeal-wrap .txt-top .txt2 {
  color: #4774ae;
}
.appeal-wrap .appeal-item .txt-small {
  font-size: 1.09rem;
  color: #999;
  padding-top: 0.818rem;
}
.appeal-wrap .type-wrap {
  margin-top: 0.818rem;
}
.appeal-wrap .type-wrap .type-main {
  margin: 0 -0.545rem;
}
.appeal-wrap .type-wrap .type-item {
  display: inline-block;
  vertical-align: top;
  box-sizing: border-box;
  padding: 0.545rem;
  text-align: center;
  width: 33.33%;
}
.appeal-wrap .type-wrap .type-item span {
  display: inline-block;
  width: 100%;
  border-radius: 0.363rem;
  height: 3.272rem;
  line-height: 3.272rem;
  background: #f7f7f7;
  font-size: 1.272rem;
}
.appeal-wrap .edittxt .content,
.appeal-wrap .edittxt .inp-content {
  background: #f7f7f7;
  border: none;
  width: 100%;
  font-size: 1.3rem;
  border-radius: 0.5rem;
}
.appeal-wrap .edittxt .content {
  height: 10rem;
  padding: 1rem;
}
input,
textarea {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}
button,
input,
select,
textarea {
  -webkit-appearance: none;
}

.appeal-wrap .appeal-item.pt13 {
  padding-top: 1.363rem;
}
.appeal-wrap .edittxt {
  margin-top: 1.363rem;
}

element.style {
}
.appeal-wrap .edittxt .inp-content {
  height: 3.8rem;
  padding-left: 1rem;
  box-sizing: border-box;
}
.m-auto-list {
  margin: 0 0 -0.25rem;
  max-width: 100%;
  overflow: hidden;
  font-size: 0;
  padding: 0;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: hidden;
}
.weui-uploader__bd {
  margin-bottom: -4px;
  margin-right: -9px;
  overflow: normal;
  display: inline-block;
  width: 100%;
}
.m-auto-item,
.m-auto-item .item-img {
  display: inline-block;
  position: relative;
}
.m-auto-item {
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 33.33%;
  padding: 0 0.5125rem 0.5125rem 0;
}
.m-auto-item .add-item {
  text-align: center;
  border: 1px dashed #999;
  border-radius: 5px;
  padding-bottom: 100%;
  height: 0;
  position: relative;
  display: inline-block;
  width: 100%;
}
.flex_center {
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.appeal-wrap .appeal-item .publish-photo-item .add-item .add-item-upload2 {
  position: static;
}

.m-auto-item .add-item .add-item-upload {
  border-radius: 5px;
  border: none;
  display: inline-block;
  position: static;
  margin-bottom: 9px;
  width: 5rem;
  height: 5rem;
  margin-top: 15px;
}
.appeal_box .appeal-btn {
  padding: 0 1.2rem;
  margin-top: 3.8rem;
}
.appeal_box .appeal-btn .btn-sub {
  width: 100%;
  background: #dea767;
  height: 3.865rem;
  line-height: 3.865rem;
  text-align: center;
  color: #fff;
  font-size: 1.45rem;
  border-radius: 10rem;
}
.appeal-wrap .type-wrap .type-item span.current {
  background: #e4803c;
  color: #fff;
}
.m-auto-item .add-item .add-item-upload:before {
  width: 4px;
  height: 39.5px;
}
.m-auto-item .add-item .add-item-upload:after,
.m-auto-item .add-item .add-item-upload:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  background-color: #999;
  border-radius: 6px;
}
.m-auto-item .add-item .add-item-upload:after {
  width: 39.5px;
  height: 4px;
}
</style>
